TKConfig.HERO = {
    [TKConfig.COUNTRY_WEI]: {
        [1]: {
            nameZH: "曹操",
            nameEN: "Cao Cao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.5,
            defend: 0.7,
            skills: ["來人護駕"],
        },
        [2]: {
            nameZH: "郭嘉",
            nameEN: "Guo Jia",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.85,
            defend: 0.85,
            skills: ["天妒之才"],
        },
        [3]: {
            nameZH: "夏侯惇",
            nameEN: "Xiahou Dun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.3,
            defend: 1.1,
            skills: ["拔矢啖睛"],
        },
        [4]: {
            nameZH: "曹仁",
            nameEN: "Cao Ren",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 1,
            skills: ["絕對防禦"],
        },
        [5]: {
            nameZH: "樂進",
            nameEN: "Yue Jin",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.4,
            defend: 0.7,
            skills: ["驍勇善戰"],
        },
        [6]: {
            nameZH: "典韋",
            nameEN: "Dian Wei",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.25,
            defend: 1.25,
            skills: ["孤身殿後"],
        },
        [7]: {
            nameZH: "徐晃",
            nameEN: "Xu Huang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.2,
            defend: 1,
            skills: ["渙散突襲"],
        },
        [8]: {
            nameZH: "許攸",
            nameEN: "Xu You",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["蜀國克星"],
        },
        [9]: {
            nameZH: "滿寵",
            nameEN: "Man Chong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["吳國克星"],
        },
        [10]: {
            nameZH: "曹洪",
            nameEN: "Cao Hong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["群雄克星"],
        },
        [11]: {
            nameZH: "曹純",
            nameEN: "Cao Chun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["武將克星"],
        },
        [12]: {
            nameZH: "楊修",
            nameEN: "Yang Xiu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["謀士克星"],
        },
        [13]: {
            nameZH: "于禁",
            nameEN: "Yu Jin",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.3,
            skills: ["陣前嘲諷"],
        },
        [14]: {
            nameZH: "張繡",
            nameEN: "Zhang Xiu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["梟雄克星"],
        },
        [15]: {
            nameZH: "王朗",
            nameEN: "Wang Lang",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["名人克星"],
        },
        [16]: {
            nameZH: "甄宓",
            nameEN: "Zhen Fu",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.8,
            defend: 1,
            skills: ["洛神歌賦"],
        },
        [17]: {
            nameZH: "華歆",
            nameEN: "Hua Xin",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["蜀國強禦"],
        },
        [18]: {
            nameZH: "曹丕",
            nameEN: "Cao Pi",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.15,
            defend: 0.85,
            skills: ["帝王之才"],
        },
        [19]: {
            nameZH: "李典",
            nameEN: "Li Dian",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["吳國強禦"],
        },
        [20]: {
            nameZH: "王異",
            nameEN: "Wang Yi",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["群雄強禦"],
        },
        [21]: {
            nameZH: "張遼",
            nameEN: "Zhang Liao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.3,
            defend: 1.1,
            skills: ["以少勝多"],
        },
        [22]: {
            nameZH: "許褚",
            nameEN: "Xu Chu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1.4,
            skills: ["虎癡怒吼"],
        },
        [23]: {
            nameZH: "陳群",
            nameEN: "Chen Qun",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["武將強攻"],
        },
        [24]: {
            nameZH: "荀彧",
            nameEN: "Xun Yu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 0.9,
            skills: ["驅虎吞狼"],
        },
        [25]: {
            nameZH: "惡曹操",
            nameEN: "Magic Cao Cao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.2,
            defend: 1,
            skills: ["地獄之門"],
        },
        [26]: {
            nameZH: "程昱",
            nameEN: "Cheng Yu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["謀士強攻"],
        },
        [27]: {
            nameZH: "曹植",
            nameEN: "Cao Zhi",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1.2,
            skills: ["風花雪月"],
        },
        [28]: {
            nameZH: "朱靈",
            nameEN: "Zhu Ling",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["梟雄強攻"],
        },
        [29]: {
            nameZH: "龐德",
            nameEN: "Pang De",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.5,
            defend: 0.9,
            skills: ["瞄準弱點"],
        },
        [30]: {
            nameZH: "司馬朗",
            nameEN: "Sima Lang",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["名人強攻"],
        },
        [31]: {
            nameZH: "瞳夏侯惇",
            nameEN: "Magic Xiahou Dun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.3,
            defend: 1.1,
            skills: ["魔瞳宿主", "魔瞳刻印"],
        },
        [32]: {
            nameZH: "曹彰",
            nameEN: "Cao Zhang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["吳國強攻"],
        },
        [33]: {
            nameZH: "賈詡",
            nameEN: "Jia Xu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["算無遺策", "亂世鬼才"],
        },
        [34]: {
            nameZH: "張春華",
            nameEN: "Zhang Chunhua",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["群雄強攻"],
        },
        [35]: {
            nameZH: "夏侯淵",
            nameEN: "Xiahou Yuan",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.1,
            skills: ["致命一擊"],
        },
        [36]: {
            nameZH: "煉郭嘉",
            nameEN: "Magic Guo Jia",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_EX,
            attack: 0.8,
            defend: 0.8,
            skills: ["自魄煉化"],
        },
        [37]: {
            nameZH: "毌丘儉",
            nameEN: "Guanqiu Jian",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["蜀國強攻"],
        },
        [38]: {
            nameZH: "蔡文姬",
            nameEN: "Cai Wenji",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 0.9,
            skills: ["才女悲歌"],
        },
        [39]: {
            nameZH: "蝠甄宓",
            nameEN: "Magic Zhen Fu",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.9,
            skills: ["羅剎魔蝠"],
        },
        [40]: {
            nameZH: "文聘",
            nameEN: "Wen Pin",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["武將強禦"],
        },
        [41]: {
            nameZH: "狂許褚",
            nameEN: "Magic Xu Chu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.6,
            defend: 0.8,
            skills: ["狂戰不息"],
        },
        [42]: {
            nameZH: "諸葛誕",
            nameEN: "Zhuge Dan",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["謀士強禦"],
        },
        [43]: {
            nameZH: "狼曹仁",
            nameEN: "Magic Cao Ren",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.4,
            defend: 1.2,
            skills: ["暴虐天狼"],
        },
        [44]: {
            nameZH: "張郃",
            nameEN: "Zhang He",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.25,
            defend: 0.9,
            skills: ["料敵先機"],
        },
        [45]: {
            nameZH: "夏侯尚",
            nameEN: "Xiahou Shang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["名人強禦"],
        },
        [46]: {
            nameZH: "荀攸",
            nameEN: "Xun You",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.1,
            skills: ["偷樑換柱"],
        },
        [47]: {
            nameZH: "祭曹植",
            nameEN: "Magic Cao Zhi",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 1.1,
            defend: 1.1,
            skills: ["哀歌祭夙"],
        },
        [48]: {
            nameZH: "鄧艾",
            nameEN: "Deng Ai",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["梟雄強禦"],
        },
        [49]: {
            nameZH: "源蔡文姬",
            nameEN: "Magic Cai Wenji",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 1.3,
            defend: 1.2,
            skills: ["本源逆溯"],
        },
        [60]: {
            nameZH: "司馬懿",
            nameEN: "Sima Yi",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.85,
            defend: 0.85,
            skills: ["韜光養晦"],
        },
    },
    [TKConfig.COUNTRY_SHU]: {
        [1]: {
            nameZH: "劉備",
            nameEN: "Liu Bei",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.7,
            defend: 1.5,
            skills: ["替我出征"],
        },
        [2]: {
            nameZH: "趙雲",
            nameEN: "Zhao Yun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.85,
            defend: 0.85,
            skills: ["一身是膽"],
        },
        [3]: {
            nameZH: "黃忠",
            nameEN: "Huang Zhong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 0.9,
            skills: ["慧眼如炬", "老當益壯"],
        },
        [4]: {
            nameZH: "魏延",
            nameEN: "Wei Yan",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.3,
            skills: ["嗜血成性"],
        },
        [5]: {
            nameZH: "馬謖",
            nameEN: "Ma Su",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 0.8,
            skills: ["紙上談兵"],
        },
        [6]: {
            nameZH: "劉禪",
            nameEN: "Liu Shan",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 1.25,
            skills: ["樂不思蜀"],
        },
        [7]: {
            nameZH: "孟獲",
            nameEN: "Meng Huo",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.4,
            defend: 1.1,
            skills: ["南蠻入侵"],
        },
        [8]: {
            nameZH: "糜芳",
            nameEN: "Mi Fang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["吳國克星"],
        },
        [9]: {
            nameZH: "周倉",
            nameEN: "Zhou Cang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["群雄克星"],
        },
        [10]: {
            nameZH: "關興",
            nameEN: "Guan Xing",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["魏國克星"],
        },
        [11]: {
            nameZH: "劉封",
            nameEN: "Liu Feng",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["謀士克星"],
        },
        [12]: {
            nameZH: "李嚴",
            nameEN: "Li Yan",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["梟雄克星"],
        },
        [13]: {
            nameZH: "姜維",
            nameEN: "Jiang Wei",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.3,
            skills: ["陣前嘲諷"],
        },
        [14]: {
            nameZH: "孫乾",
            nameEN: "Sun Qian",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["名人克星"],
        },
        [15]: {
            nameZH: "陳到",
            nameEN: "Chen Dao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["武將克星"],
        },
        [16]: {
            nameZH: "張飛",
            nameEN: "Zhang Fei",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.4,
            defend: 1,
            skills: ["一夫當關", "殺意正濃"],
        },
        [17]: {
            nameZH: "關銀屏",
            nameEN: "Guan Yinping",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["吳國強禦"],
        },
        [18]: {
            nameZH: "徐庶",
            nameEN: "Xu Shu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.85,
            defend: 1.15,
            skills: ["心在蜀漢"],
        },
        [19]: {
            nameZH: "糜竺",
            nameEN: "Mi Zhu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["群雄強禦"],
        },
        [20]: {
            nameZH: "張星彩",
            nameEN: "Zhang Xingcai",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["魏國強禦"],
        },
        [21]: {
            nameZH: "關羽",
            nameEN: "Guan Yu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.5,
            defend: 1.3,
            skills: ["龍戰於野"],
        },
        [22]: {
            nameZH: "王平",
            nameEN: "Wang Ping",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.7,
            defend: 1.4,
            skills: ["無當飛軍"],
        },
        [23]: {
            nameZH: "張苞",
            nameEN: "Zhang Bao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["謀士強攻"],
        },
        [24]: {
            nameZH: "黃月英",
            nameEN: "Huang Yueying",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 0.8,
            skills: ["木牛流馬"],
        },
        [25]: {
            nameZH: "荒劉備",
            nameEN: "Magic Liu Bei",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 0.7,
            defend: 0.9,
            skills: ["荒漠幻影"],
        },
        [26]: {
            nameZH: "廖化",
            nameEN: "Liao Hua",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["梟雄強攻"],
        },
        [27]: {
            nameZH: "法正",
            nameEN: "Fa Zheng",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1,
            skills: ["奇謀妙計"],
        },
        [28]: {
            nameZH: "沙摩柯",
            nameEN: "Shamo Ke",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["名人強攻"],
        },
        [29]: {
            nameZH: "祝融",
            nameEN: "Zhu Rong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.1,
            skills: ["火神之名"],
        },
        [30]: {
            nameZH: "馮習",
            nameEN: "Feng Xi",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["武將強攻"],
        },
        [31]: {
            nameZH: "金黃忠",
            nameEN: "Magic Huangzhong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1,
            defend: 1,
            skills: ["黃金之弓"],
        },
        [32]: {
            nameZH: "簡雍",
            nameEN: "Jian Yong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["群雄強攻"],
        },
        [33]: {
            nameZH: "諸葛亮",
            nameEN: "Zhuge Liang",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["軍師錦囊", "足智多謀"],
        },
        [34]: {
            nameZH: "馬岱",
            nameEN: "Ma Dai",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["吳國強攻"],
        },
        [35]: {
            nameZH: "馬良",
            nameEN: "Ma Liang",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.85,
            defend: 0.85,
            skills: ["白眉才氣"],
        },
        [36]: {
            nameZH: "噬法正",
            nameEN: "Magic Fa Zheng",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_EX,
            attack: 0.95,
            defend: 0.95,
            skills: ["原界噬能"],
        },
        [37]: {
            nameZH: "許靖",
            nameEN: "Xu Jing",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["魏國強攻"],
        },
        [38]: {
            nameZH: "關平",
            nameEN: "Guan Ping",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 0.9,
            skills: ["關聖太子"],
        },
        [39]: {
            nameZH: "龍黃月英",
            nameEN: "Magic Huang Yueying",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 0.85,
            defend: 0.85,
            skills: ["臥龍點睛"],
        },
        [40]: {
            nameZH: "董允",
            nameEN: "Dong Yun",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["武將強禦"],
        },
        [41]: {
            nameZH: "薩孟獲",
            nameEN: "Magic Meng Huo",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.9,
            skills: ["象主降臨"],
        },
        [42]: {
            nameZH: "關索",
            nameEN: "Guan Suo",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["名人強禦"],
        },
        [43]: {
            nameZH: "聖關羽",
            nameEN: "Magic Guan Yu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.4,
            defend: 1.2,
            skills: ["龍魂入聖"],
        },
        [44]: {
            nameZH: "龐統",
            nameEN: "Pang Tong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.95,
            defend: 0.95,
            skills: ["鳳雛妙計", "鐵索連環"],
        },
        [45]: {
            nameZH: "楊儀",
            nameEN: "Yang Yi",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["梟雄強禦"],
        },
        [46]: {
            nameZH: "蔣琬",
            nameEN: "Jiang Wan",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["身負重托"],
        },
        [47]: {
            nameZH: "影姜維",
            nameEN: "Majic Jiang Wei",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_EX,
            attack: 1.4,
            defend: 1.3,
            skills: ["幻影遺志"],
        },
        [48]: {
            nameZH: "費祎",
            nameEN: "Fei Yi",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["謀士強禦"],
        },
        [60]: {
            nameZH: "馬超",
            nameEN: "Ma Chao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["西涼鐵騎"],
        },
        [999]: {
            nameZH: "靈象",
            nameEN: "Ling Xiang",
            type: TKConfig.HERO_TYPE_,
            rarity: TKConfig.RARITY_EX,
            attack: 1,
            defend: 1,
            skills: [],
        },
    },
    [TKConfig.COUNTRY_WU]: {
        [1]: {
            nameZH: "孫權",
            nameEN: "Sun Quan",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.3,
            defend: 1.3,
            skills: ["攻防制衡"],
        },
        [2]: {
            nameZH: "小喬",
            nameEN: "Xiao Qiao",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.9,
            defend: 0.9,
            skills: ["國色天香"],
        },
        [3]: {
            nameZH: "大喬",
            nameEN: "Da Qiao",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["清風玉露", "月明星稀"],
        },
        [4]: {
            nameZH: "魯肅",
            nameEN: "Lu Su",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.1,
            skills: ["仗義疏財"],
        },
        [5]: {
            nameZH: "黃蓋",
            nameEN: "Huang Gai",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.25,
            defend: 0.8,
            skills: ["赤壁之火"],
        },
        [6]: {
            nameZH: "太史慈",
            nameEN: "Taishi Ci",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 0.9,
            skills: ["壯志未酬"],
        },
        [7]: {
            nameZH: "張昭",
            nameEN: "Zhang Zhao",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 0.8,
            skills: ["敢於直諫"],
        },
        [8]: {
            nameZH: "蔣欽",
            nameEN: "Jiang Qin",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["群雄克星"],
        },
        [9]: {
            nameZH: "丁奉",
            nameEN: "Ding Feng",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["魏國克星"],
        },
        [10]: {
            nameZH: "潘璋",
            nameEN: "Pan Zhang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["蜀國克星"],
        },
        [11]: {
            nameZH: "徐盛",
            nameEN: "Xu Sheng",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["梟雄克星"],
        },
        [12]: {
            nameZH: "馬忠",
            nameEN: "Ma Zhong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["名人克星"],
        },
        [13]: {
            nameZH: "諸葛瑾",
            nameEN: "Zhuge Jin",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["子瑜之驢"],
        },
        [14]: {
            nameZH: "虞翻",
            nameEN: "Yu Fan",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["武將克星"],
        },
        [15]: {
            nameZH: "顧雍",
            nameEN: "Gu Yong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["謀士克星"],
        },
        [16]: {
            nameZH: "呂蒙",
            nameEN: "Lv Meng",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["刮目相看", "陣前嘲諷"],
        },
        [17]: {
            nameZH: "陳武",
            nameEN: "Chen Wu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["群雄強禦"],
        },
        [18]: {
            nameZH: "孫堅",
            nameEN: "Sun Jian",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.3,
            defend: 0.9,
            skills: ["銳不可當"],
        },
        [19]: {
            nameZH: "周泰",
            nameEN: "Zhou Tai",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["魏國強禦"],
        },
        [20]: {
            nameZH: "吳國太",
            nameEN: "Wu Guotai",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["蜀國強禦"],
        },
        [21]: {
            nameZH: "孫策",
            nameEN: "Sun Ce",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.2,
            defend: 1,
            skills: ["同歸於盡"],
        },
        [22]: {
            nameZH: "甘寧",
            nameEN: "Gan Ning",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.2,
            defend: 1.2,
            skills: ["過河拆橋"],
        },
        [23]: {
            nameZH: "朱然",
            nameEN: "Zhu Ran",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["梟雄強攻"],
        },
        [24]: {
            nameZH: "陸遜",
            nameEN: "Lu Xun",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["擅於火攻", "火燒連營"],
        },
        [25]: {
            nameZH: "淵孫權",
            nameEN: "Magic Sun Quan",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.9,
            skills: ["淵主傳承"],
        },
        [26]: {
            nameZH: "步練師",
            nameEN: "Bu Lianshi",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["名人強攻"],
        },
        [27]: {
            nameZH: "程普",
            nameEN: "Cheng Pu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.3,
            skills: ["陣前嘲諷"],
        },
        [28]: {
            nameZH: "淩操",
            nameEN: "Ling Cao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["武將強攻"],
        },
        [29]: {
            nameZH: "張纮",
            nameEN: "Zhang Hong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.1,
            skills: ["小巫大巫"],
        },
        [30]: {
            nameZH: "淩統",
            nameEN: "Ling Tong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["謀士強攻"],
        },
        [31]: {
            nameZH: "緋太史慈",
            nameEN: "Magic Taishi Ci",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.1,
            defend: 1.1,
            skills: ["多重地獄"],
        },
        [32]: {
            nameZH: "諸葛恪",
            nameEN: "Zhuge Ke",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["名人強禦"],
        },
        [33]: {
            nameZH: "孫尚香",
            nameEN: "Sun Shangxiang",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["吳蜀聯姻"],
        },
        [34]: {
            nameZH: "嚴畯",
            nameEN: "Yan Jun",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["魏國強攻"],
        },
        [35]: {
            nameZH: "韓當",
            nameEN: "Han Dang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 1.1,
            skills: ["病逝任上"],
        },
        [36]: {
            nameZH: "鯉魯肅",
            nameEN: "Magic Lu Su",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_EX,
            attack: 0.85,
            defend: 0.85,
            skills: ["魚躍龍門"],
        },
        [37]: {
            nameZH: "胡綜",
            nameEN: "Hu Zong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["武將強禦"],
        },
        [38]: {
            nameZH: "朱桓",
            nameEN: "Zhu Huan",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 1.1,
            skills: ["聲東擊西"],
        },
        [39]: {
            nameZH: "巫小喬",
            nameEN: "Magic Xiaoqiao",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 1.1,
            defend: 1.2,
            skills: ["神兵召喚"],
        },
        [40]: {
            nameZH: "孫韶",
            nameEN: "Sun Shao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["群雄強攻"],
        },
        [41]: {
            nameZH: "獅甘寧",
            nameEN: "Magic Gan Ning",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 1.3,
            skills: ["狂獅刃甲"],
        },
        [42]: {
            nameZH: "周魴",
            nameEN: "Zhou Fang",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["蜀國強攻"],
        },
        [43]: {
            nameZH: "槐孫策",
            nameEN: "Magic Sun Ce",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.5,
            defend: 1.3,
            skills: ["霸王庇蔭"],
        },
        [44]: {
            nameZH: "陸凱",
            nameEN: "Lu Kai",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["陸凱貴盛"],
        },
        [45]: {
            nameZH: "全琮",
            nameEN: "Quan Zong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["梟雄強禦"],
        },
        [46]: {
            nameZH: "步騭",
            nameEN: "Bu Zhi",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["匡救賢良"],
        },
        [47]: {
            nameZH: "根大喬",
            nameEN: "Majic Da Qiao",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.8,
            skills: ["根源重構"],
        },
        [48]: {
            nameZH: "陸抗",
            nameEN: "Lu Kang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["謀士強禦"],
        },
        [60]: {
            nameZH: "周瑜",
            nameEN: "Zhou Yu",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.9,
            defend: 0.9,
            skills: ["假死之計"],
        },
        [998]: {
            nameZH: "巨神兵",
            nameEN: "Ju Shenbing",
            type: TKConfig.HERO_TYPE_,
            rarity: TKConfig.RARITY_EX,
            attack: 1,
            defend: 1,
            skills: ["遠古兵器", "任務終了"],
        },
        [999]: {
            nameZH: "子瑜之驢",
            nameEN: "Ziyu's Donkey",
            type: TKConfig.HERO_TYPE_,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["陣前嘲諷"],
        },
    },
    [TKConfig.COUNTRY_QUN]: {
        [1]: {
            nameZH: "張角",
            nameEN: "Zhang Jiao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["替天行道"],
        },
        [2]: {
            nameZH: "貂蟬",
            nameEN: "Diao Chan",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.9,
            defend: 0.9,
            skills: ["閉月羞花"],
        },
        [3]: {
            nameZH: "袁紹",
            nameEN: "Yuan Shao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 0.9,
            skills: ["火上澆油", "火攻之怨"],
        },
        [4]: {
            nameZH: "于吉",
            nameEN: "Yu Ji",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 1,
            skills: ["變化多端"],
        },
        [5]: {
            nameZH: "馬騰",
            nameEN: "Ma Teng",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.15,
            defend: 1.15,
            skills: ["涼州驃騎"],
        },
        [6]: {
            nameZH: "公孫瓚",
            nameEN: "Gongsun Zan",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.3,
            skills: ["牢不可破"],
        },
        [7]: {
            nameZH: "華雄",
            nameEN: "Hua Xiong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 0.5,
            skills: ["旗開得勝"],
        },
        [8]: {
            nameZH: "韓遂",
            nameEN: "Han Sui",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["魏國克星"],
        },
        [9]: {
            nameZH: "何進",
            nameEN: "He Jin",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["蜀國克星"],
        },
        [10]: {
            nameZH: "淳于瓊",
            nameEN: "Chunyu Qiong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["吳國克星"],
        },
        [11]: {
            nameZH: "潘鳳",
            nameEN: "Pan Feng",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["名人克星"],
        },
        [12]: {
            nameZH: "胡車兒",
            nameEN: "Hu Cheer",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["武將克星"],
        },
        [13]: {
            nameZH: "陳宮",
            nameEN: "Chen Gong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 0.9,
            skills: ["拒降赴死"],
        },
        [14]: {
            nameZH: "王允",
            nameEN: "Wang Yun",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["謀士克星"],
        },
        [15]: {
            nameZH: "董承",
            nameEN: "Dong Cheng",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 1,
            defend: 1,
            skills: ["梟雄克星"],
        },
        [16]: {
            nameZH: "華佗",
            nameEN: "Hua Tuo",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 0.85,
            defend: 0.65,
            skills: ["妙手回春"],
        },
        [17]: {
            nameZH: "邢道榮",
            nameEN: "Xing Daorong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["魏國強禦"],
        },
        [18]: {
            nameZH: "袁術",
            nameEN: "Yuan Shu",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.3,
            skills: ["陣前嘲諷"],
        },
        [19]: {
            nameZH: "田豐",
            nameEN: "Tian Feng",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["蜀國強禦"],
        },
        [20]: {
            nameZH: "李儒",
            nameEN: "Li Ru",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["吳國強禦"],
        },
        [21]: {
            nameZH: "左慈",
            nameEN: "Zuo Ci",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["仙人之姿"],
        },
        [22]: {
            nameZH: "劉表",
            nameEN: "Liu Biao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.2,
            defend: 1,
            skills: ["擁兵自守"],
        },
        [23]: {
            nameZH: "紀靈",
            nameEN: "Ji Ling",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["名人強攻"],
        },
        [24]: {
            nameZH: "董卓",
            nameEN: "Dong Zhuo",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1,
            defend: 1,
            skills: ["酒池肉林", "日漸崩壞"],
        },
        [25]: {
            nameZH: "幻張角",
            nameEN: "Magic Zhang Jiao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.3,
            defend: 1.3,
            skills: ["儲雷轟殺"],
        },
        [26]: {
            nameZH: "孔融",
            nameEN: "Kong Rong",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["武將強攻"],
        },
        [27]: {
            nameZH: "沮授",
            nameEN: "Ju Shou",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_SR,
            attack: 0.8,
            defend: 1,
            skills: ["不降身死"],
        },
        [28]: {
            nameZH: "曹性",
            nameEN: "Cao Xing",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["謀士強攻"],
        },
        [29]: {
            nameZH: "張梁",
            nameEN: "Zhang Liang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 0.9,
            defend: 1.1,
            skills: ["亡靈吟唱", "亡靈咒縛"],
        },
        [30]: {
            nameZH: "劉璋",
            nameEN: "Liu Zhang",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["梟雄強攻"],
        },
        [31]: {
            nameZH: "蛛華雄",
            nameEN: "Magic Hua Xiong",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.1,
            defend: 1.1,
            skills: ["狼蛛劇毒"],
        },
        [32]: {
            nameZH: "張魯",
            nameEN: "Zhang Lu",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["魏國強攻"],
        },
        [33]: {
            nameZH: "呂布",
            nameEN: "Lv Bu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SSR,
            attack: 1.8,
            defend: 1.8,
            skills: [],
        },
        [34]: {
            nameZH: "陶謙",
            nameEN: "Tao Qian",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["謀士強禦"],
        },
        [35]: {
            nameZH: "張寶",
            nameEN: "Zhang Bao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.1,
            defend: 0.9,
            skills: ["清風移木"],
        },
        [36]: {
            nameZH: "傀陳宮",
            nameEN: "Magic Chen Gong",
            type: TKConfig.HERO_TYPE_MOUSHI,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.9,
            skills: ["布影傀儡"],
        },
        [37]: {
            nameZH: "蔡瑁",
            nameEN: "Cai Mao",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["蜀國強攻"],
        },
        [38]: {
            nameZH: "顏良",
            nameEN: "Yan Liang",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1,
            defend: 0.85,
            skills: ["一鼓作氣", "三鼓而竭"],
        },
        [39]: {
            nameZH: "魂貂蟬",
            nameEN: "Magic Diaochan",
            type: TKConfig.HERO_TYPE_MINGREN,
            rarity: TKConfig.RARITY_EX,
            attack: 0.95,
            defend: 1.05,
            skills: ["赤兔畫戟"],
        },
        [40]: {
            nameZH: "張允",
            nameEN: "Zhang Yun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 0.9,
            defend: 1.2,
            skills: ["吳國強攻"],
        },
        [41]: {
            nameZH: "囚馬騰",
            nameEN: "Magic Ma Teng",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.25,
            defend: 1.25,
            skills: ["次元囚籠"],
        },
        [42]: {
            nameZH: "審配",
            nameEN: "Shen Pei",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["名人強禦"],
        },
        [43]: {
            nameZH: "猙袁紹",
            nameEN: "Magic Yuan Shao",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.3,
            defend: 1.25,
            skills: ["猙卍之力"],
        },
        [44]: {
            nameZH: "文醜",
            nameEN: "Wen Chou",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.15,
            defend: 1.25,
            skills: ["二夫之勇"],
        },
        [45]: {
            nameZH: "黃祖",
            nameEN: "Huang Zu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["武將強禦"],
        },
        [46]: {
            nameZH: "高順",
            nameEN: "Gao Shun",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_SR,
            attack: 1.35,
            defend: 0.75,
            skills: ["登鋒陷陣"],
        },
        [47]: {
            nameZH: "璽袁術",
            nameEN: "Magic Yuan Shu",
            type: TKConfig.HERO_TYPE_XIAOXIONG,
            rarity: TKConfig.RARITY_EX,
            attack: 0.9,
            defend: 0.9,
            skills: ["璽靈役魂"],
        },
        [48]: {
            nameZH: "張任",
            nameEN: "Zhang Ren",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_R,
            attack: 1.2,
            defend: 0.9,
            skills: ["梟雄強禦"],
        },
        [999]: {
            nameZH: "傀儡呂布",
            nameEN: "Puppet Lv Bu",
            type: TKConfig.HERO_TYPE_WUJIANG,
            rarity: TKConfig.RARITY_EX,
            attack: 1.8,
            defend: 1.8,
            skills: [],
        },
    },
};

TKConfig.SKILL = {
    ["蜀克魏"]: {
        name: "蜀克魏",
        desc: "蜀國英雄與魏國英雄戰鬥時，蜀國英雄的計算戰力+50%",
    },
    ["吳克蜀"]: {
        name: "吳克蜀",
        desc: "吳國英雄與蜀國英雄戰鬥時，吳國英雄的計算戰力+50%",
    },
    ["魏克吳"]: {
        name: "魏克吳",
        desc: "魏國英雄與吳國英雄戰鬥時，魏國英雄的計算戰力+50%",
    },
    ["點燃"]: {
        name: "點燃",
        desc: "攻擊時，計算攻擊戰力-20%",
    },
    ["渙散"]: {
        name: "渙散",
        desc: "被攻擊時，計算防禦戰力-20%",
    },
    ["靶心"]: {
        name: "靶心",
        desc: "敵方選擇攻擊目標時，自身成為優先選擇目標，優先順序2",
    },
    ["劇毒"]: {
        name: "劇毒",
        desc: "戰鬥開始時，戰力-15%",
    },
    ["連環"]: {
        name: "連環",
        desc: "戰鬥時，計算戰力加存活連環狀態隊友戰力的35%，減死亡連環狀態隊友戰力的15%",
    },
    ["致殘"]: {
        name: "致殘",
        desc: "戰鬥時，計算戰力-35%，且死亡後無法復活",
    },
    ["復活"]: {
        name: "復活",
        desc: "死亡後，使自身復活",
    },
    ["龍佑"]: {
        name: "龍佑",
        desc: "免疫戰鬥死亡",
    },
    ["清風"]: {
        name: "清風",
        desc: "獲得狀態後，清除自身所有狀態",
    },
    ["沉默"]: {
        name: "沉默",
        desc: "戰鬥開始時，沉默對手，直到回合結束",
    },
    ["繼承"]: {
        name: "繼承",
        desc: "隊友死亡後，技能增加到自身身上",
    },
    ["遺志"]: {
        name: "遺志",
        desc: "死亡後，技能增加到隨機1名隊友身上",
    },
    ["戰神"]: {
        name: "戰神",
        desc: "戰鬥開始時，戰力+20%",
    },
    ["殺意"]: {
        name: "殺意",
        desc: "攻擊前，攻擊戰力+40%",
    },
    ["金剛"]: {
        name: "金剛",
        desc: "被攻擊前，防禦戰力+40%",
    },
    ["無為"]: {
        name: "無為",
        desc: "戰鬥開始時，沉默自身，直到回合結束",
    },
    ["喪志"]: {
        name: "喪志",
        desc: "被攻擊前，使自身和隨機1名隊友獲得渙散狀態",
    },
    ["自焚"]: {
        name: "自焚",
        desc: "攻擊前，使自身和隨機1名隊友獲得點燃狀態",
    },
    ["毒發"]: {
        name: "毒發",
        desc: "戰鬥開始時，使自身獲得劇毒狀態",
    },
    ["無力"]: {
        name: "無力",
        desc: "戰鬥開始時，戰力-18%",
    },
    ["洩氣"]: {
        name: "洩氣",
        desc: "攻擊前，攻擊戰力-30%",
    },
    ["疲軟"]: {
        name: "疲軟",
        desc: "被攻擊前，防禦戰力-30%",
    },
    ["武將克星"]: {
        name: "武將克星",
        desc: "戰鬥時，若對手為武將英雄，自身計算戰力+80%",
    },
    ["武將強攻"]: {
        name: "武將強攻",
        desc: "戰鬥時，若對手為武將英雄，自身計算攻擊戰力+160%",
    },
    ["武將強禦"]: {
        name: "武將強禦",
        desc: "戰鬥時，若對手為武將英雄，自身計算防禦戰力+160%",
    },
    ["謀士克星"]: {
        name: "謀士克星",
        desc: "戰鬥時，若對手為謀士英雄，自身計算戰力+80%",
    },
    ["謀士強攻"]: {
        name: "謀士強攻",
        desc: "戰鬥時，若對手為謀士英雄，自身計算攻擊戰力+160%",
    },
    ["謀士強禦"]: {
        name: "謀士強禦",
        desc: "戰鬥時，若對手為謀士英雄，自身計算防禦戰力+160%",
    },
    ["梟雄克星"]: {
        name: "梟雄克星",
        desc: "戰鬥時，若對手為梟雄英雄，自身計算戰力+80%",
    },
    ["梟雄強攻"]: {
        name: "梟雄強攻",
        desc: "戰鬥時，若對手為梟雄英雄，自身計算攻擊戰力+160%",
    },
    ["梟雄強禦"]: {
        name: "梟雄強禦",
        desc: "戰鬥時，若對手為梟雄英雄，自身計算防禦戰力+160%",
    },
    ["名人克星"]: {
        name: "名人克星",
        desc: "戰鬥時，若對手為名人英雄，自身計算戰力+80%",
    },
    ["名人強攻"]: {
        name: "名人強攻",
        desc: "戰鬥時，若對手為名人英雄，自身計算攻擊戰力+160%",
    },
    ["名人強禦"]: {
        name: "名人強禦",
        desc: "戰鬥時，若對手為名人英雄，自身計算防禦戰力+160%",
    },
    ["魏國克星"]: {
        name: "魏國克星",
        desc: "戰鬥時，若對手為魏國英雄，自身計算戰力+80%",
    },
    ["魏國強攻"]: {
        name: "魏國強攻",
        desc: "戰鬥時，若對手為魏國英雄，自身計算攻擊戰力+160%",
    },
    ["魏國強禦"]: {
        name: "魏國強禦",
        desc: "戰鬥時，若對手為魏國英雄，自身計算防禦戰力+160%",
    },
    ["蜀國克星"]: {
        name: "蜀國克星",
        desc: "戰鬥時，若對手為蜀國英雄，自身計算戰力+80%",
    },
    ["蜀國強攻"]: {
        name: "蜀國強攻",
        desc: "戰鬥時，若對手為蜀國英雄，自身計算攻擊戰力+160%",
    },
    ["蜀國強禦"]: {
        name: "蜀國強禦",
        desc: "戰鬥時，若對手為蜀國英雄，自身計算防禦戰力+160%",
    },
    ["吳國克星"]: {
        name: "吳國克星",
        desc: "戰鬥時，若對手為吳國英雄，自身計算戰力+80%",
    },
    ["吳國強攻"]: {
        name: "吳國強攻",
        desc: "戰鬥時，若對手為吳國英雄，自身計算攻擊戰力+160%",
    },
    ["吳國強禦"]: {
        name: "吳國強禦",
        desc: "戰鬥時，若對手為吳國英雄，自身計算防禦戰力+160%",
    },
    ["群雄克星"]: {
        name: "群雄克星",
        desc: "戰鬥時，若對手為群雄英雄，自身計算戰力+80%",
    },
    ["群雄強攻"]: {
        name: "群雄強攻",
        desc: "戰鬥時，若對手為群雄英雄，自身計算攻擊戰力+160%",
    },
    ["群雄強禦"]: {
        name: "群雄強禦",
        desc: "戰鬥時，若對手為群雄英雄，自身計算防禦戰力+160%",
    },
    ["陣前嘲諷"]: {
        name: "陣前嘲諷",
        desc: "敵方選擇攻擊目標時，自身成為優先選擇目標，優先順序1",
    },
    ["偷樑換柱"]: {
        name: "偷樑換柱",
        desc: "戰鬥死亡後，將對手技能替換為“陣前嘲諷”",
    },
    ["擁兵自守"]: {
        name: "擁兵自守",
        desc: "被攻擊時，每有一個不同的國家，計算防禦戰力+20%",
    },
    ["致命一擊"]: {
        name: "致命一擊",
        desc: "戰鬥時，50%的概率計算戰力+50%",
    },
    ["來人護駕"]: {
        name: "來人護駕",
        desc: "被攻擊前，使防禦戰力最高的隊友代替自己戰鬥",
    },
    ["替我出征"]: {
        name: "替我出征",
        desc: "攻擊前，使攻擊戰力最高的隊友代替自己戰鬥",
    },
    ["攻防制衡"]: {
        name: "攻防制衡",
        desc: "戰鬥開始時，對手的計算戰力為攻擊和防禦戰力的較小值",
    },
    ["替天行道"]: {
        name: "替天行道",
        desc: "攻擊前，35%概率使對手死亡",
    },
    ["酒池肉林"]: {
        name: "酒池肉林",
        desc: "遊戲開始時，每有1名隊友，戰力+20%基礎戰力",
    },
    ["日漸崩壞"]: {
        name: "日漸崩壞",
        desc: "隊友死亡後，自身戰力-20%基礎戰力",
    },
    ["妙手回春"]: {
        name: "妙手回春",
        desc: "攻擊前，使隨機1名隊友復活，每局限1次",
    },
    ["一夫當關"]: {
        name: "一夫當關",
        desc: "攻擊時，計算攻擊戰力+50%，每回合限1次",
    },
    ["殺意正濃"]: {
        name: "殺意正濃",
        desc: "攻擊勝利後，再進行1次攻擊，每回合限1次",
    },
    ["西涼鐵騎"]: {
        name: "西涼鐵騎",
        desc: "戰鬥時，計算戰力+50%對手戰力",
    },
    ["變化多端"]: {
        name: "變化多端",
        desc: "戰鬥開始時，複製對手技能，直到回合結束",
    },
    ["旗開得勝"]: {
        name: "旗開得勝",
        desc: "攻擊必定勝利，每局限1次",
    },
    ["絕對防禦"]: {
        name: "絕對防禦",
        desc: "免疫被攻擊死亡，每局限1次",
    },
    ["瞄準弱點"]: {
        name: "瞄準弱點",
        desc: "選擇攻擊目標時，優先選擇防禦戰力最低的英雄，優先順序4",
    },
    ["孤身殿後"]: {
        name: "孤身殿後",
        desc: "對戰時，若己方英雄數量等於1，且敵方英雄數量大於1，則必定勝利，每局限3次",
    },
    ["驍勇善戰"]: {
        name: "驍勇善戰",
        desc: "被攻擊時，計算防禦戰力為對手防禦戰力",
    },
    ["無當飛軍"]: {
        name: "無當飛軍",
        desc: "攻擊時，計算攻擊戰力為對手攻擊戰力",
    },
    ["紙上談兵"]: {
        name: "紙上談兵",
        desc: "任意英雄戰鬥時，若己方英雄不是謀士，則計算戰力+20%，否則計算戰力-20%",
    },
    ["子瑜之驢"]: {
        name: "子瑜之驢",
        desc: "隊友死亡後，將該隊友替換為“子瑜之驢”，戰力為50%自身戰力，自身戰力-25%，每局限1次",
    },
    ["嘲諷克星"]: {
        name: "嘲諷克星",
        desc: "戰鬥時，若對手有“陣前嘲諷”技能，則自身計算戰力+80%",
    },
    ["關聖太子"]: {
        name: "關聖太子",
        desc: "戰鬥時，若己方關羽存活，計算戰力+25%關羽戰力",
    },
    ["聲東擊西"]: {
        name: "聲東擊西",
        desc: "遊戲開始時，敵方攻擊戰力最低的英雄跟敵方首位英雄互換位置",
    },
    ["陸凱貴盛"]: {
        name: "陸凱貴盛",
        desc: "戰鬥時，若自身站位相鄰隊友存活，計算戰力+30%其戰力",
    },
    ["二夫之勇"]: {
        name: "二夫之勇",
        desc: "戰鬥時，若己方顏良存活，計算戰力+40%其戰力；若己方顏良死亡，自身計算戰力-20%",
    },
    ["登鋒陷陣"]: {
        name: "登鋒陷陣",
        desc: "被攻擊前，自身變為攻擊方",
    },
    ["洛神歌賦"]: {
        name: "洛神歌賦",
        desc: "遊戲開始時，魏國隊友防禦戰力+30%自身基礎戰力",
    },
    ["木牛流馬"]: {
        name: "木牛流馬",
        desc: "遊戲開始時，蜀國隊友攻擊戰力+30%自身基礎戰力",
    },
    ["國色天香"]: {
        name: "國色天香",
        desc: "遊戲開始時，吳國隊友戰力+15%自身基礎戰力",
    },
    ["閉月羞花"]: {
        name: "閉月羞花",
        desc: "遊戲開始時，左右2名隊友戰力+30%自身基礎戰力",
    },
    ["驅虎吞狼"]: {
        name: "驅虎吞狼",
        desc: "遊戲開始時，使隨機2名敵方英雄戰力-25%",
    },
    ["虎癡怒吼"]: {
        name: "虎癡怒吼",
        desc: "戰鬥開始時，對手攻擊戰力-20%",
    },
    ["奇謀妙計"]: {
        name: "奇謀妙計",
        desc: "戰鬥開始時，對手戰力-20%",
    },
    ["南蠻入侵"]: {
        name: "南蠻入侵",
        desc: "戰鬥勝利後，使隨機1名敵方英雄防禦戰力-35%",
    },
    ["過河拆橋"]: {
        name: "過河拆橋",
        desc: "戰鬥勝利後，使隨機1名敵方英雄戰力-20%",
    },
    ["涼州驃騎"]: {
        name: "涼州驃騎",
        desc: "攻擊前，使隨機1名敵方英雄戰力-20%",
    },
    ["韜光養晦"]: {
        name: "韜光養晦",
        desc: "任意英雄死亡後，自身戰力+11%基礎戰力",
    },
    ["一身是膽"]: {
        name: "一身是膽",
        desc: "隊友死亡後，自身戰力+22%基礎戰力",
    },
    ["龍戰於野"]: {
        name: "龍戰於野",
        desc: "戰鬥勝利後，戰力+20%",
    },
    ["刮目相看"]: {
        name: "刮目相看",
        desc: "戰鬥開始時，防禦戰力+40%基礎戰力",
    },
    ["吳蜀聯姻"]: {
        name: "吳蜀聯姻",
        desc: "戰鬥開始時，使隨機1名吳國和1名蜀國己方英雄，戰力+17%基礎戰力",
    },
    ["嗜血成性"]: {
        name: "嗜血成性",
        desc: "戰鬥勝利後，攻擊戰力+60%對手基礎戰力",
    },
    ["拔矢啖睛"]: {
        name: "拔矢啖睛",
        desc: "戰鬥開始時，攻擊戰力+40%基礎戰力，防禦戰力-10%",
    },
    ["仗義疏財"]: {
        name: "仗義疏財",
        desc: "攻擊前，使隨機1名己方英雄戰力+35%基礎戰力",
    },
    ["一鼓作氣"]: {
        name: "一鼓作氣",
        desc: "遊戲開始時，每存活一個武將隊友，戰力+15%基礎戰力",
    },
    ["三鼓而竭"]: {
        name: "三鼓而竭",
        desc: "戰鬥勝利後，戰力-20%",
    },
    ["同歸於盡"]: {
        name: "同歸於盡",
        desc: "戰鬥死亡後，40%概率使對手死亡",
    },
    ["假死之計"]: {
        name: "假死之計",
        desc: "死亡後，使自身復活，每局限1次",
    },
    ["天妒之才"]: {
        name: "天妒之才",
        desc: "死亡後，使隨機1名隊友戰力+100%自身戰力",
    },
    ["壯志未酬"]: {
        name: "壯志未酬",
        desc: "戰鬥死亡後，對手戰力-35%",
    },
    ["舍生相救"]: {
        name: "舍生相救",
        desc: "隊友戰鬥死亡後，使該隊友復活，並使自身死亡",
    },
    ["才女悲歌"]: {
        name: "才女悲歌",
        desc: "死亡後，使隨機1名魏國和1名群雄己方英雄戰力+25%基礎戰力",
    },
    ["換命重生"]: {
        name: "換命重生",
        desc: "戰鬥死亡後，使自身復活，並使戰力總和最低的隊友死亡，每局限1次",
    },
    ["拒降赴死"]: {
        name: "拒降赴死",
        desc: "死亡後，使隨機2名敵方英雄戰力-20%",
    },
    ["不降身死"]: {
        name: "不降身死",
        desc: "死亡後，使隨機2名隊友防禦戰力+50%",
    },
    ["樂不思蜀"]: {
        name: "樂不思蜀",
        desc: "遊戲開始時，使隨機2名敵方英雄獲得渙散狀態",
    },
    ["風花雪月"]: {
        name: "風花雪月",
        desc: "戰鬥開始時，使隨機1名敵方英雄獲得渙散狀態",
    },
    ["渙散突襲"]: {
        name: "渙散突襲",
        desc: "戰鬥時，每有1名敵方英雄處於渙散狀態，計算戰力+30%基礎戰力",
    },
    ["慧眼如炬"]: {
        name: "慧眼如炬",
        desc: "選擇攻擊目標時，優先選擇處於渙散狀態的英雄，優先順序4",
    },
    ["老當益壯"]: {
        name: "老當益壯",
        desc: "攻擊時，若對手處於渙散狀態，自身計算戰力+120%",
    },
    ["亡靈吟唱"]: {
        name: "亡靈吟唱",
        desc: "戰鬥勝利後，使隨機1名敵方英雄獲得渙散狀態",
    },
    ["亡靈咒縛"]: {
        name: "亡靈咒縛",
        desc: "死亡後，使隨機2名敵方英雄獲得渙散狀態",
    },
    ["赤壁之火"]: {
        name: "赤壁之火",
        desc: "遊戲開始時，使隨機2名敵方英雄獲得點燃狀態",
    },
    ["擅於火攻"]: {
        name: "擅於火攻",
        desc: "戰鬥開始時，使隨機1名敵方英雄獲得點燃狀態",
    },
    ["火燒連營"]: {
        name: "火燒連營",
        desc: "戰鬥時，每有1名敵方英雄處於點燃狀態，計算戰力+30%基礎戰力",
    },
    ["火神之名"]: {
        name: "火神之名",
        desc: "戰鬥時，若對手處於點燃狀態，自身計算戰力+150%",
    },
    ["火上澆油"]: {
        name: "火上澆油",
        desc: "戰鬥勝利後，使隨機1名敵方英雄獲得點燃狀態",
    },
    ["火攻之怨"]: {
        name: "火攻之怨",
        desc: "死亡後，使隨機2名敵方英雄獲得點燃狀態",
    },
    ["清風玉露"]: {
        name: "清風玉露",
        desc: "戰鬥開始時，清除隨機1名己方英雄的全部狀態",
    },
    ["月明星稀"]: {
        name: "月明星稀",
        desc: "戰鬥開始時，清除隨機1名己方英雄的全部綠色錦囊",
    },
    ["清心之咒"]: {
        name: "清心之咒",
        desc: "戰鬥勝利後，清除隨機2名己方英雄的全部狀態",
    },
    ["清風移木"]: {
        name: "清風移木",
        desc: "攻擊前，將隨機1名己方英雄的全部狀態和綠色錦囊轉移給隨機1名敵方英雄",
    },
    ["匡救賢良"]: {
        name: "匡救賢良",
        desc: "隊友戰鬥開始前，有40%概率清除所有狀態",
    },
    ["鳳雛妙計"]: {
        name: "鳳雛妙計",
        desc: "遊戲開始時，獲得連環狀態",
    },
    ["鐵索連環"]: {
        name: "鐵索連環",
        desc: "戰鬥開始時，使隨機1名隊友獲得連環狀態",
    },
    ["仙人之姿"]: {
        name: "仙人之姿",
        desc: "戰鬥時，勝率+12%",
    },
    ["銳不可當"]: {
        name: "銳不可當",
        desc: "戰鬥時，若自身攻擊戰力大於對手攻擊戰力，則勝率+10%",
    },
    ["牢不可破"]: {
        name: "牢不可破",
        desc: "戰鬥時，若自身防禦戰力大於對手防禦戰力，則勝率+10%",
    },
    ["以少勝多"]: {
        name: "以少勝多",
        desc: "戰鬥時，若己方存活英雄數量小於敵方存活英雄數量，則勝率+20%",
    },
    ["帝王之才"]: {
        name: "帝王之才",
        desc: "戰鬥時，若對手不是武將英雄，則自身勝率+12%",
    },
    ["心在蜀漢"]: {
        name: "心在蜀漢",
        desc: "戰鬥時，若對手不是蜀國英雄，則自身勝率+9%",
    },
    ["敢於直諫"]: {
        name: "敢於直諫",
        desc: "隊友戰鬥時，若勝率小於50%，則勝率+5%",
    },
    ["小巫大巫"]: {
        name: "小巫大巫",
        desc: "戰鬥時，若自身勝率高於對手勝率，則勝率+15%；若自身勝率低於對手勝率，則勝率-7.5%",
    },
    ["白眉才氣"]: {
        name: "白眉才氣",
        desc: "己方英雄戰鬥時，若對手是謀士，則己方勝率+8%",
    },
    ["料敵先機"]: {
        name: "料敵先機",
        desc: "敵方英雄首次戰鬥時，勝率-5%，並且自身戰力-15%",
    },
    ["地獄之門"]: {
        name: "地獄之門",
        desc: "攻擊前，觸發隨機1名隊友的非戰鬥死亡技能",
    },
    ["荒漠幻影"]: {
        name: "荒漠幻影",
        desc: "死亡後，替換為隨機SSR或SR英雄",
    },
    ["淵主傳承"]: {
        name: "淵主傳承",
        desc: "戰鬥時，計算戰力+25%；戰鬥死亡後，使隨機1名隊友獲得此技能",
    },
    ["儲雷轟殺"]: {
        name: "儲雷轟殺",
        desc: "累計戰鬥勝利2次後，使隨機1名敵方英雄死亡，並清空累計勝利次數",
    },
    ["魔瞳宿主"]: {
        name: "魔瞳宿主",
        desc: "遊戲開始時，使防禦戰力最低的敵方英雄獲得靶心狀態",
    },
    ["魔瞳刻印"]: {
        name: "魔瞳刻印",
        desc: "攻擊前，使防禦戰力最低的敵方英雄獲得靶心狀態",
    },
    ["狼蛛劇毒"]: {
        name: "狼蛛劇毒",
        desc: "戰鬥開始時，使攻擊防禦戰力之和最高的敵方英雄獲得劇毒狀態",
    },
    ["黃金之弓"]: {
        name: "黃金之弓",
        desc: "戰鬥時，計算戰力隨機-60%、+40%、+80%、+120%、+200%，概率均等",
    },
    ["多重地獄"]: {
        name: "多重地獄",
        desc: "死亡後，使隨機2名敵方英雄戰力-15%，且每戰鬥勝利1次則額外再-15%",
    },
    ["自魄煉化"]: {
        name: "自魄煉化",
        desc: "隊友戰鬥時，若自身在場且已死亡，則35%概率隊友計算戰力加成自身戰力",
    },
    ["原界噬能"]: {
        name: "原界噬能",
        desc: "敵方英雄戰鬥勝利後，戰力-12%，並加成到自身戰力",
    },
    ["魚躍龍門"]: {
        name: "魚躍龍門",
        desc: "隊友戰鬥時，積蓄隊友戰力的20%；自身戰鬥時，計算戰力加成積蓄戰力，並清空積蓄戰力",
    },
    ["布影傀儡"]: {
        name: "布影傀儡",
        desc: "攻擊前，將己方隨機1位隊友替換為傀儡呂布（攻180% 防180%），且繼承自身基礎戰力和隊友技能，每局限1次",
    },
    ["羅剎魔蝠"]: {
        name: "羅剎魔蝠",
        desc: "遊戲開始時，隨機選擇3名敵方英雄，吸取其15%戰力",
    },
    ["臥龍點睛"]: {
        name: "臥龍點睛",
        desc: "隊友戰鬥死亡後，對手獲得1個綠色錦囊，且50%概率隨機1名隊友獲得1個紅色錦囊",
    },
    ["神兵召喚"]: {
        name: "神兵召喚",
        desc: "戰鬥勝利後，替換為巨神兵",
    },
    ["遠古兵器"]: {
        name: "遠古兵器",
        desc: "戰鬥時，計算戰力為99999999",
    },
    ["任務終了"]: {
        name: "任務終了",
        desc: "戰鬥勝利後，替換為巫小喬",
    },
    ["赤兔畫戟"]: {
        name: "赤兔畫戟",
        desc: "戰鬥時，計算戰力+己方2名已死亡最高戰力英雄40%戰力",
    },
    ["狂戰不息"]: {
        name: "狂戰不息",
        desc: "隊友攻擊前，若其攻擊戰力低于自身，則自身代替其戰鬥",
    },
    ["象主降臨"]: {
        name: "象主降臨",
        desc: "戰鬥開始時，將隨機1個死亡隊友替換為靈象，其戰力為自身50%戰力；戰鬥時，計算戰力+己方所有靈象戰力",
    },
    ["狂獅刃甲"]: {
        name: "狂獅刃甲",
        desc: "攻擊時，計算攻擊戰力+35%防禦戰力；被攻擊時，對手計算攻擊戰力-35%自身防禦戰力",
    },
    ["囚籠"]: {
        name: "囚籠",
        desc: "無法攻擊和被攻擊，施放者死亡時效果解除，一方英雄全部處於囚籠效果時遊戲失敗",
    },
    ["次元囚籠"]: {
        name: "次元囚籠",
        desc: "戰鬥勝利後，使隨機1名敵方英雄獲得囚籠特效。（囚籠：無法攻擊和被攻擊，施放者死亡時效果解除，一方英雄全部處於囚籠效果時遊戲失敗）",
    },
    ["龍魂入聖"]: {
        name: "龍魂入聖",
        desc: "戰鬥勝利後，獲得龍佑錦囊",
    },
    ["暴虐天狼"]: {
        name: "暴虐天狼",
        desc: "戰鬥勝利後，隨機1名敵方英雄獲得致殘狀態",
    },
    ["霸王庇蔭"]: {
        name: "霸王庇蔭",
        desc: "戰鬥勝利後，使隨機1名隊友戰力+25%",
    },
    ["猙卍之力"]: {
        name: "猙卍之力",
        desc: "攻擊前，對手防禦戰力-20%自身攻擊戰力；被攻擊前，對手攻擊戰力-20%自身防禦戰力",
    },
    ["哀歌祭夙"]: {
        name: "哀歌祭夙",
        desc: "戰鬥前，複製己方已死亡的最高戰力英雄的技能和屬性，並且計算戰力增加原先戰力的25%，回合結束后恢復",
    },
    ["幻影遺志"]: {
        name: "幻影遺志",
        desc: "戰鬥勝利後，將一個死亡隊友替換為存活隊友的幻影；幻影戰鬥結束後消失",
    },
    ["根源重構"]: {
        name: "根源重構",
        desc: "死亡後，隊友戰鬥勝利次數累計2次，則自身復活且戰力+55%，同時清空累計次數",
    },
    ["璽靈役魂"]: {
        name: "璽靈役魂",
        desc: "戰鬥時，計算戰力+場上所有死亡英雄10%的戰力",
    },
    ["軍師錦囊"]: {
        name: "軍師錦囊",
        desc: "遊戲開始時，使隨機2名己方英雄獲得1個紅色錦囊",
    },
    ["足智多謀"]: {
        name: "足智多謀",
        desc: "戰鬥勝利後，使隨機1名己方英雄獲得1個紅色錦囊",
    },
    ["算無遺策"]: {
        name: "算無遺策",
        desc: "戰鬥開始時，清除隨機1名敵方英雄的全部紅色錦囊",
    },
    ["亂世鬼才"]: {
        name: "亂世鬼才",
        desc: "戰鬥開始時，使隨機2名敵方英雄獲得1個綠色錦囊",
    },
    ["病逝任上"]: {
        name: "病逝任上",
        desc: "死亡後，使隨機2名敵方英雄獲得1個綠色錦囊",
    },
    ["身負重托"]: {
        name: "身負重托",
        desc: "擁有紅色錦囊的隊友戰鬥開始前，有50%概率讓隨機1名隊友獲得1個紅色錦囊",
    },
    ["本源逆溯"]: {
        name: "本源逆溯",
        desc: "戰鬥勝利後，將一個死亡隊友替換為自身分身，分身無技能且戰力為自身的80%；自身戰鬥死亡後，將繼承本體戰力在分身上復活",
    },
};
